<template>
    <at-breadcrumb>
        <at-breadcrumb-item>
            Главная
        </at-breadcrumb-item>
        <at-breadcrumb-item :href="`#/${item.type}/${item.id}`" v-for="(item, id) in getList" :key="id">
            {{item.name}}
        </at-breadcrumb-item>
    </at-breadcrumb>
</template>

<script>
export default {
    computed: {
        page() {
            return this.$route.params.id
        },
        cat() {
            return this.$route.params.type == 'cat'
        },
        getList() {
            var next = 0
            var thislist = this.list
            thislist.splice(0)
            if (this.cat) {
                let item = this.$store.state.cats.data.find(val => val.id == this.page)
                if (item !== 'undefined') {
                    thislist.push(item)
                    next = item.parent
                } else next = 0
            } else {
                let item = this.$store.state.pages.data.find(val => val.id == this.page)
                if (item !== 'undefined') {
                    thislist.push(item)
                    next = item.category
                } else next = 0

            }
            var deep = 0
            while (next > 0 && deep < 10) {
                deep++
                let item = this.$store.state.cats.data.find(val => val.id == next)
                if (item !== 'undefined') {
                    thislist.push(item)
                    if (item.parent == next) next = 0
                    else next = item.parent
                } else next = 0
            }
            return thislist.reverse()
        }
    },
    data: () => ({
        list: []
    })
};
</script>
